import React, { type ComponentType } from 'react'

import { Box, Stack, Typography } from '@mui/material'
import CustomerBomboraCompaniesUsage from 'features/customers/components/usage/CustomerBomboraCompaniesUsage'
import CustomerBomboraCompaniesUsageResetButton from 'features/customers/components/usage/CustomerBomboraCompaniesUsageResetButton'
import CustomerContactsPhoneUsage from 'features/customers/components/usage/CustomerContactsPhoneUsage'
import CustomerContactsQuotaLimit from 'features/customers/components/usage/CustomerContactsQuotaLimit'
import CustomerLeadsUsage from 'features/customers/components/usage/CustomerLeadsUsage'
import CustomerOutreachSeatsUsage from 'features/customers/components/usage/CustomerOutreachSeatsUsage'

import { EFeatureNames } from '@albacross/types'

import { Dash } from 'components/_base'

export const USAGE_WIDTH = 130

const CompactBomboraReset = () => <CustomerBomboraCompaniesUsageResetButton compact />

type UsageLine = { Usage: ComponentType; Action?: ComponentType }

// Components, not hooks: React only runs the hooks it mounts, so rows with no usage source cost nothing.
export const USAGE_BY_FEATURE: Partial<Record<string, UsageLine>> = {
  [EFeatureNames.LeadsLimit]: { Usage: CustomerLeadsUsage },
  [EFeatureNames.ContactsUsageLimit]: { Usage: CustomerContactsQuotaLimit },
  [EFeatureNames.ContactsPhoneNumbersLimit]: { Usage: CustomerContactsPhoneUsage },
  [EFeatureNames.BomboraCompanies]: { Usage: CustomerBomboraCompaniesUsage, Action: CompactBomboraReset },
  [EFeatureNames.OutreachSenders]: { Usage: CustomerOutreachSeatsUsage },
}

type Props = { name: string }

const CustomerFeatureUsage = ({ name }: Props) => {
  const line = USAGE_BY_FEATURE[name]

  if (!line) {
    return <Dash />
  }

  const { Usage, Action } = line

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
      <Box sx={{ width: USAGE_WIDTH, flexShrink: 0 }}>
        <Usage />
      </Box>
      {Action && <Action />}
    </Stack>
  )
}

export default CustomerFeatureUsage
